// All İONA services with full detail and benefits
// Used on landing services grid + dedicated detail pages /hizmetler/:slug

export const SERVICES = [
  {
    slug: "lazer-epilasyon",
    title: "Lazer Epilasyon",
    short:
      "Hibrit Alexandrite, Buz Lazer ve Diode teknolojileriyle kişiye özel lazer epilasyon uygulamaları.",
    detail:
      "İONA Güzellik Merkezi'nde lazer epilasyon uygulamaları, kişinin cilt tipi, kıl yapısı ve uygulama bölgesine göre planlanır. Hibrit Alexandrite, Buz Lazer ve Diode teknolojileriyle daha konforlu, güvenli ve etkili bir epilasyon süreci hedeflenir. Düzenli seanslarla istenmeyen tüy görünümünün azaltılmasına yardımcı olur.",
    benefits: [
      "İstenmeyen tüy görünümünü azaltmaya yardımcı olur",
      "Daha pürüzsüz bir cilt görünümü destekler",
      "Kadın ve erkeklere özel uygulama planı yapılabilir",
      "Bölgeye ve kıl yapısına göre kişiye özel seans planlanır",
      "Konforlu ve hızlı uygulama imkânı sunar",
    ],
    cta: "Ücretsiz Deneme Seansı Al",
    category: "Lazer",
    icon: "Zap",
    image: "/services/lazer-epilasyon.png",
  },
  {
    slug: "bolgesel-incelme",
    title: "Bölgesel İncelme",
    short:
      "G5, EMS, Lenf Drenaj, Bubbles ve şekillendirme uygulamalarıyla bölgesel incelme desteği.",
    detail:
      "Bölgesel incelme uygulamaları, vücutta dirençli yağlanma, ödem ve şekil bozukluğu görülen bölgeler için destekleyici bakım protokolleridir. İONA'da uygulama planı kişinin ihtiyacına göre hazırlanır. G5 masajı, EMS, Lenf Drenaj, Bubbles, Magic Probe ve benzeri teknolojilerle vücut hatlarının daha sıkı, toparlanmış ve şekilli görünmesi hedeflenir.",
    benefits: [
      "Bölgesel sıkılaşmaya yardımcı olur",
      "Ödem görünümünü azaltmaya destek olur",
      "Vücut hatlarının daha belirgin görünmesini destekler",
      "Selülit görünümünün azalmasına yardımcı olur",
      "Kişiye özel seans programı oluşturulur",
    ],
    cta: "Bölgesel İncelme İçin Bilgi Al",
    category: "Vücut Şekillendirme",
    icon: "Activity",
    image: "/services/bolgesel-incelme.png",
  },
  {
    slug: "saten-vucut-germe",
    title: "Saten Vücut Germe",
    short:
      "Radyo frekans ve ısı teknolojisiyle vücutta ameliyatsız sıkılaştırma ve toparlama desteği.",
    detail:
      "Saten vücut germe uygulaması, karın, basen, kalça, kol ve bacak gibi gevşeme görülen bölgelerde ameliyatsız sıkılaştırmayı hedefleyen bir bakım protokolüdür. Radyo frekans ve ısı teknolojisiyle cilt altındaki kolajen üretimini desteklemeye yardımcı olur. Doğum, kilo değişimi ya da yaşa bağlı oluşan gevşeme görünümünü toparlamaya destek olur.",
    benefits: [
      "Vücutta gevşemiş bölgelerin toparlanmasına yardımcı olur",
      "Karın, basen, kol ve bacak bölgesinde sıkılaşma desteği sağlar",
      "Cildin daha sıkı ve canlı görünmesine destek olur",
      "Kolajen üretimini destekleyici bir uygulamadır",
      "Ameliyatsız ve konforlu bir bakım protokolüdür",
    ],
    cta: "Saten Vücut Germe Randevusu Al",
    category: "Vücut Şekillendirme",
    icon: "Hourglass",
    image: "/services/saten-vucut-germe.png",
  },
  {
    slug: "saten-yuz-germe",
    title: "Saten Yüz Germe",
    short:
      "Radyo frekans ve ısı teknolojisiyle ameliyatsız yüz sıkılaştırma, gıdı toparlama ve cilt yenileme desteği.",
    detail:
      "Saten yüz germe uygulaması, ameliyatsız yüz sıkılaştırma ve toparlama hedefleyen özel bir bakım protokolüdür. Radyo frekans ve ısı teknolojisiyle cilt altındaki kolajen üretimini desteklemeye yardımcı olur. Yüz ovalinin belirginleşmesi, gıdı bölgesinin toparlanması, çene hattının daha net görünmesi ve cildin daha sıkı bir görünüme kavuşması hedeflenir.",
    benefits: [
      "Yüz ovalini belirginleştirmeye yardımcı olur",
      "Gıdı bölgesinde toparlanma sağlar",
      "Çene hattının daha net görünmesini destekler",
      "Cildin daha sıkı ve canlı görünmesine yardımcı olur",
      "İnce çizgi görünümünü azaltmaya destek olur",
      "Ameliyatsız ve konforlu bir uygulamadır",
    ],
    cta: "Saten Yüz Germe Randevusu Al",
    category: "Cilt Bakımı",
    icon: "Sparkles",
    image: "/services/saten-yuz-germe.png",
  },
  {
    slug: "hydrafacial",
    title: "Hydrafacial Cilt Bakımı",
    short:
      "Cildi derinlemesine arındırmaya, nemlendirmeye ve daha canlı bir görünüm kazandırmaya yardımcı bakım uygulaması.",
    detail:
      "Hydrafacial cilt bakımı, cildi derinlemesine temizlemeyi, ölü deriden arındırmayı, nemlendirmeyi ve cilde daha parlak bir görünüm kazandırmayı hedefleyen profesyonel bir bakım uygulamasıdır. Cilt ihtiyacına göre planlanan bakım protokolü ile daha temiz, canlı ve sağlıklı bir cilt görünümü desteklenir.",
    benefits: [
      "Cildi derinlemesine temizlemeye yardımcı olur",
      "Gözenek görünümünü azaltmaya destek olur",
      "Cilde nem ve parlaklık kazandırır",
      "Daha canlı ve taze bir görünüm sağlar",
      "Cilt bakım rutinini destekler",
    ],
    cta: "Hydrafacial Randevusu Al",
    category: "Cilt Bakımı",
    icon: "Droplets",
    image: "/services/hydrafacial.png",
  },
  {
    slug: "profesyonel-cilt-bakimi",
    title: "Profesyonel Cilt Bakımı",
    short:
      "Cilt tipine ve ihtiyacına göre kişiye özel hazırlanan profesyonel bakım protokolü.",
    detail:
      "Profesyonel cilt bakımı, cildin ihtiyacına göre planlanan kişiye özel bir bakım uygulamasıdır. Cilt temizliği, arındırma, nemlendirme ve bakım adımlarıyla cildin daha dengeli, canlı ve sağlıklı görünmesi hedeflenir. Yağlı, kuru, karma veya hassas ciltlere özel bakım planı oluşturulabilir.",
    benefits: [
      "Cildi temizlemeye ve arındırmaya yardımcı olur",
      "Cilt dengesini destekler",
      "Daha sağlıklı ve canlı bir görünüm sağlar",
      "Cilt tipine özel bakım uygulanır",
      "Düzenli bakım ile cilt kalitesini destekler",
    ],
    cta: "Cilt Bakımı İçin Randevu Al",
    category: "Cilt Bakımı",
    icon: "Leaf",
    image: "/services/profesyonel-cilt-bakimi.png",
  },
  {
    slug: "kore-cilt-bakimi",
    title: "Kore Cilt Bakımı",
    short: "Leke görünümü, matlık ve cilt tonu eşitsizliği için özel bakım protokolü.",
    detail:
      "Kore cilt bakımı, ciltteki mat görünüm, ton eşitsizliği, leke görünümü ve nem kaybı gibi ihtiyaçlara yönelik hazırlanan özel bir bakım protokolüdür. Cildin daha aydınlık, dengeli, nemli ve parlak görünmesini destekler. Özellikle canlılık ve ışıltı isteyen ciltler için tercih edilebilir.",
    benefits: [
      "Cilt tonu eşitsizliğini azaltmaya yardımcı olur",
      "Leke görünümünü hafifletmeye destek olur",
      "Cilde daha aydınlık bir görünüm kazandırır",
      "Nem dengesini destekler",
      "Daha parlak ve sağlıklı bir cilt görünümü sağlar",
    ],
    cta: "Kore Cilt Bakımı İçin Bilgi Al",
    category: "Cilt Bakımı",
    icon: "Flower2",
    image: "/services/kore-cilt-bakimi.png",
  },
  {
    slug: "3d-cilt-analizi",
    title: "3D Cilt Analizi",
    short: "Cildin ihtiyacını belirlemek için detaylı analiz ve kişiye özel bakım planı.",
    detail:
      "3D cilt analizi, cildin nem dengesi, leke görünümü, gözenek durumu, ince çizgi görünümü ve genel cilt yapısını değerlendirmeye yardımcı olur. Analiz sonucuna göre kişiye en uygun bakım ve uygulama planı oluşturulur. İONA'da cilt bakım sürecinin daha doğru planlanması için önemli bir adımdır.",
    benefits: [
      "Cilt ihtiyaçlarını detaylı değerlendirmeye yardımcı olur",
      "Kişiye özel bakım protokolü oluşturulur",
      "Leke, nem, gözenek ve cilt kalitesi analiz edilir",
      "Doğru uygulama seçimi yapılmasını destekler",
      "Cilt bakım sürecini daha bilinçli hale getirir",
    ],
    cta: "Ücretsiz Cilt Analizi Al",
    category: "Analiz",
    icon: "ScanLine",
    image: "/services/3d-cilt-analizi.png",
  },
  {
    slug: "g5-masaji",
    title: "G5 Masajı",
    short:
      "Bölgesel incelme, selülit görünümü ve sıkılaşma desteği için uygulanan masaj protokolü.",
    detail:
      "G5 masajı, özel titreşimli masaj cihazı ile uygulanan bölgesel şekillendirme ve sıkılaşma destekli bir uygulamadır. Özellikle bacak, basen, kalça ve karın bölgelerinde tercih edilir. Selülit görünümünü azaltmaya, kan dolaşımını desteklemeye ve vücut hatlarının daha toparlanmış görünmesine yardımcı olur.",
    benefits: [
      "Selülit görünümünü azaltmaya yardımcı olur",
      "Bölgesel sıkılaşmayı destekler",
      "Kan dolaşımını desteklemeye yardımcı olur",
      "Ödem görünümünün azalmasına destek olur",
      "Vücut hatlarının daha toparlanmış görünmesini sağlar",
    ],
    cta: "G5 Masajı İçin Bilgi Al",
    category: "Vücut Şekillendirme",
    icon: "Waves",
    image: "/services/g5-masaji.png",
  },
  {
    slug: "ems",
    title: "EMS",
    short: "Kas aktivasyonunu destekleyen, vücut şekillendirme odaklı uygulama.",
    detail:
      "EMS uygulaması, elektromanyetik kas uyarımı ile kasların aktif şekilde çalışmasını destekleyen bir vücut şekillendirme uygulamasıdır. Karın, kalça, bacak ve kol gibi bölgelerde uygulanabilir. Düzenli seanslarla daha sıkı ve şekilli bir görünüm hedeflenir.",
    benefits: [
      "Kas aktivasyonunu destekler",
      "Vücut sıkılaşmasına yardımcı olur",
      "Karın, kalça ve bacak bölgelerinde uygulanabilir",
      "Spor ve beslenme düzenini destekleyici bir uygulamadır",
      "Daha şekilli vücut görünümüne katkı sağlar",
    ],
    cta: "EMS Randevusu Al",
    category: "Vücut Şekillendirme",
    icon: "Dumbbell",
    image: "/services/ems.png",
  },
  {
    slug: "lenf-drenaj",
    title: "Lenf Drenaj",
    short:
      "Ödem görünümünü azaltmaya ve vücudu rahatlatmaya yardımcı destekleyici uygulama.",
    detail:
      "Lenf drenaj uygulaması, vücuttaki ödem hissini azaltmaya ve dolaşımı desteklemeye yardımcı olan konforlu bir uygulamadır. Bölgesel incelme programlarıyla birlikte tercih edilebilir. Vücudun daha hafif, rahat ve toparlanmış hissetmesini destekler.",
    benefits: [
      "Ödem görünümünü azaltmaya yardımcı olur",
      "Vücudu rahatlatır",
      "Dolaşımı desteklemeye yardımcı olur",
      "Bölgesel incelme sürecini destekler",
      "Daha hafif ve konforlu bir his sağlar",
    ],
    cta: "Lenf Drenaj İçin Randevu Al",
    category: "Vücut Şekillendirme",
    icon: "Wind",
    image: "/services/lenf-drenaj.png",
  },
  {
    slug: "microblading",
    title: "Microblading",
    short:
      "Kaş formunu belirginleştirmeye yardımcı doğal görünümlü kaş tasarımı uygulaması.",
    detail:
      "Microblading, kaşların daha dolgun, simetrik ve belirgin görünmesini hedefleyen yarı kalıcı kaş tasarımı uygulamasıdır. Yüz şekline ve doğal kaş yapısına uygun tasarım yapılır. Doğal görünüm korunarak kaş formunun daha net hale gelmesi amaçlanır.",
    benefits: [
      "Kaş formunu belirginleştirir",
      "Daha dolgun kaş görünümü sağlar",
      "Yüz hatlarına uygun tasarım yapılır",
      "Doğal görünüm hedeflenir",
      "Günlük makyaj ihtiyacını azaltmaya yardımcı olur",
    ],
    cta: "Microblading İçin Bilgi Al",
    category: "Güzellik",
    icon: "Brush",
    image: "/services/microblading.png",
  },
  {
    slug: "kas-laminasyon",
    title: "Kaş Laminasyon",
    short:
      "Kaşların daha taranmış, dolgun ve şekilli görünmesini sağlayan bakım uygulaması.",
    detail:
      "Kaş laminasyon uygulaması, kaş kıllarını yukarı doğru sabitleyerek daha dolgun, düzenli ve şekilli bir görünüm kazandırır. Seyrek veya dağınık kaş görünümünü toparlamaya yardımcı olur. Doğal ve bakımlı kaş görünümü isteyenler için idealdir.",
    benefits: [
      "Kaşları daha dolgun gösterir",
      "Dağınık kaş görünümünü toparlar",
      "Daha düzenli ve kalkık kaş formu sağlar",
      "Doğal ve bakımlı görünüm sunar",
      "Günlük kaş sabitleme ihtiyacını azaltır",
    ],
    cta: "Kaş Laminasyon Randevusu Al",
    category: "Güzellik",
    icon: "Eye",
    image: "/services/kas-laminasyon.png",
  },
  {
    slug: "kirpik-lifting",
    title: "Kirpik Lifting",
    short:
      "Doğal kirpikleri daha kıvrık, uzun ve belirgin göstermeye yardımcı uygulama.",
    detail:
      "Kirpik lifting, doğal kirpiklerin özel solüsyonlarla kıvrık ve kalkık görünmesini sağlayan bakım uygulamasıdır. Maskara etkisine yakın, doğal ve bakımlı bir görünüm hedeflenir. Takma kirpik kullanmadan daha belirgin bakışlar elde etmeye yardımcı olur.",
    benefits: [
      "Kirpikleri daha kıvrık gösterir",
      "Bakışları daha belirgin hale getirir",
      "Doğal kirpiklerle uygulanır",
      "Maskara etkisine yakın görünüm sağlar",
      "Günlük makyaj süresini azaltmaya yardımcı olur",
    ],
    cta: "Kirpik Lifting Randevusu Al",
    category: "Güzellik",
    icon: "Star",
    image: "/services/kirpik-lifting.png",
  },
  {
    slug: "dudak-renklendirme",
    title: "Dudak Renklendirme",
    short:
      "Dudaklara daha canlı, dengeli ve doğal renk görünümü kazandırmaya yardımcı yarı kalıcı uygulama.",
    detail:
      "Dudak renklendirme, dudak rengini daha canlı, dengeli ve belirgin hale getirmeyi hedefleyen yarı kalıcı bir uygulamadır. Doğal tonlarda renk seçimiyle dudaklara daha sağlıklı ve bakımlı bir görünüm kazandırılır. Kişinin yüz tonu ve dudak yapısına uygun renk planlaması yapılır.",
    benefits: [
      "Dudak rengini daha canlı gösterir",
      "Soluk dudak görünümünü azaltmaya yardımcı olur",
      "Daha bakımlı ve doğal görünüm sağlar",
      "Kişiye özel renk seçimi yapılır",
      "Günlük ruj kullanımını azaltmaya yardımcı olabilir",
    ],
    cta: "Dudak Renklendirme İçin Bilgi Al",
    category: "Güzellik",
    icon: "Heart",
    image: "/services/dudak-renklendirme.png",
  },
  {
    slug: "ignesiz-mezoterapi",
    title: "İğnesiz Mezoterapi",
    short:
      "Cilde nem, parlaklık ve canlılık kazandırmaya yardımcı konforlu bakım uygulaması.",
    detail:
      "İğnesiz mezoterapi, cilt bakım içeriklerinin iğne kullanılmadan cilde uygulanmasını hedefleyen konforlu bir bakım yöntemidir. Cildin daha nemli, canlı ve parlak görünmesine yardımcı olur. Matlık, nem kaybı ve yorgun cilt görünümüne karşı destekleyici bir uygulamadır.",
    benefits: [
      "Cilde nem desteği sağlar",
      "Daha parlak ve canlı görünüm kazandırır",
      "Yorgun cilt görünümünü azaltmaya yardımcı olur",
      "Konforlu bir bakım uygulamasıdır",
      "Cilt bakım protokollerini destekler",
    ],
    cta: "İğnesiz Mezoterapi Randevusu Al",
    category: "Cilt Bakımı",
    icon: "Droplet",
    image: "/services/ignesiz-mezoterapi.png",
  },
  {
    slug: "cilt-aydinlatma",
    title: "Cilt Beyazlatma / Aydınlatma Bakımı",
    short:
      "Cilt tonu eşitsizliği ve koyu görünüm için aydınlatıcı bakım protokolü.",
    detail:
      "Cilt beyazlatma ve aydınlatma bakımı, ciltteki ton eşitsizliği, mat görünüm ve koyu alanların daha dengeli görünmesine yardımcı olmak için planlanan bakım protokolüdür. Cildin daha aydınlık, parlak ve eşit tonlu görünmesini destekler.",
    benefits: [
      "Cilt tonunun daha dengeli görünmesine yardımcı olur",
      "Mat görünümü azaltmaya destek olur",
      "Daha aydınlık cilt görünümü sağlar",
      "Bölgesel koyuluk görünümünü hafifletmeye yardımcı olur",
      "Cildin daha canlı görünmesini destekler",
    ],
    cta: "Aydınlatma Bakımı İçin Bilgi Al",
    category: "Cilt Bakımı",
    icon: "Sun",
    image: "/services/cilt-aydinlatma.png",
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
